import Vue from 'vue'
import store from '@/store'

Vue.directive('check-type', {
  inserted(el, binding, node) {
    const types = Array.isArray(binding.value) ? binding.value : [binding.value]
    const strict = !!binding.modifiers.strict
    if (!types.some(type => store.getters['permissions/isUserHasType'](type, strict))) {
      node.elm.parentElement.removeChild(node.elm)
    }
  },
})
